import { createBaseMobileLogger } from './mobile-logger';
import { MOBILE_WIDGET } from 'shared/worker/actions/fedopsLogger';

export default createBaseMobileLogger(MOBILE_WIDGET);
